import { Link } from 'react-router-dom';

interface MidCTAProps {
  headline?: string;
  sub?: string;
  btnLabel?: string;
  btnTo?: string;
  urgency?: string;
  variant?: 'teal' | 'orange' | 'sand';
}

export default function MidCTA({
  headline = 'Don\'t Miss Your Next Session',
  sub = 'Pick up a kit before your next surf — repairs take minutes, not days.',
  btnLabel = 'Shop Repair Kits',
  btnTo = '/products',
  urgency = 'Free Micro Kit with orders over $40',
  variant = 'teal',
}: MidCTAProps) {
  const bgMap = {
    teal: 'bg-[#0B5C4D]',
    orange: 'bg-[#FF6B35]',
    sand: 'bg-[#F5EFE6]',
  };
  const textMap = {
    teal: 'text-white',
    orange: 'text-white',
    sand: 'text-stone-900',
  };
  const subMap = {
    teal: 'text-white/70',
    orange: 'text-white/80',
    sand: 'text-stone-500',
  };
  const btnMap = {
    teal: 'bg-[#FF6B35] text-white hover:bg-[#e55a25]',
    orange: 'bg-white text-[#FF6B35] hover:bg-stone-100',
    sand: 'bg-[#0B5C4D] text-white hover:bg-[#094d3f]',
  };
  const urgencyMap = {
    teal: 'text-[#FF6B35]',
    orange: 'text-white/90',
    sand: 'text-[#FF6B35]',
  };

  return (
    <div className={`${bgMap[variant]} py-10`}>
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
        <div>
          <h3 className={`font-black text-2xl md:text-3xl ${textMap[variant]}`}>{headline}</h3>
          <p className={`text-sm mt-1 ${subMap[variant]}`}>{sub}</p>
        </div>
        <div className="flex flex-col items-center gap-2 flex-shrink-0">
          <Link
            to={btnTo}
            className={`whitespace-nowrap font-bold px-8 py-3.5 rounded-full transition-colors cursor-pointer ${btnMap[variant]}`}
          >
            {btnLabel}
          </Link>
          {urgency && (
            <p className={`text-xs font-semibold flex items-center gap-1.5 ${urgencyMap[variant]}`}>
              <i className="ri-gift-line" />
              {urgency}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
